import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import sparklesSmallTokens from "@amzn/meridian-tokens/base/icon/sparkles-small";
import { THEME_COLOR } from "../styles/colors";

// "<name> turned on ..." status for a session someone else started.
const StartedByStatus = ({ startedBy }) => (
  <Row spacing="300" alignmentVertical="top" spacingInset="none none 400 none">
    <Theme tokens={{ iconColorSecondary: THEME_COLOR.SEAFOAM_GREEN }}>
      <Icon tokens={sparklesSmallTokens} color="secondary" />
    </Theme>
    <Column spacing="none">
      <Text type="h50">{startedBy.name}</Text>
      <Text type="b200">{startedBy.description}</Text>
    </Column>
  </Row>
);

export default StartedByStatus;
